export default "__VITE_ASSET__CSdF0Nfa__"